import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { TipoSolicitudService } from '../../infrastructure/services/tiposolicitud.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'sx-listado-tiposolicitud',
  templateUrl: './listado.tiposolicitud.component.html',
  providers: [ItemGeneralListado],
})
export class ListadoTipoSolicitudComponent implements OnInit {
   tiposolicitud: Observable<ItemGeneralListado[]>;

  constructor(private tipoSolicitudService: TipoSolicitudService,
    private router: Router, private aRoute: ActivatedRoute ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
         this.tiposolicitud = this.tipoSolicitudService.getForList();
    });
  }

  navegarNuevoTipoSolicitud() {
    this.router.navigate(['/soc/tiposolicitud', 'nuevo']);
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/tiposolicitud/listado.tiposolicitud.component.ts